import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectLayoutQueryItems } from '../../../../redux/layouts/selector';
import { layouts } from '../../../../redux/layouts/action';
import LayoutComponent from '../components/layout.component';
import { websites } from '../../../../redux/websites/action';
import { selectPageListItems } from '../../../../redux/pages/selector';
import { selectWebsiteListItems } from '../../../../redux/websites/selector';
import { pages } from '../../../../redux/pages/action';
import { format } from '../../../../common/services/date.service';
import { formatPageListData, formatWebsiteListData } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { selectCardListItems } from '../../../../redux/cards/selector';
import { cards } from '../../../../redux/cards/action';


const Layout= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const pagesLists = useSelector(selectPageListItems)
  const websitesLists = useSelector(selectWebsiteListItems)
  const routeQuery = useSelector(selectLayoutQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)  
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const cardList = useSelector(selectCardListItems)
var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
const [pageData, setPageData] = useState(1)
  const [
    selectedRoute,
    setSelectedRoute
  ] = useState<any>([])
  const [
    cardDetails,
    setCards
  ] = useState<any>([])
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      
      { field: 'message.CardName', headerName: 'CardName', sortable: true, filter: true,isEdit: true }, 
      { field: 'message.CardVersionId', headerName: 'Card Version' },
      { field: 'message.CreatedOnUtc', headerName: 'Created Date', valueFormatter: format }
  
    ]);
  }
  const fetchLayoutById= ()=>{

    dispatch(layouts.query({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/query`,entity:'layouts',jsonData:{
          
    Records: [
      {
        
          "context": {},
          "message": {
              "Id": parmas?.id,
              "TenantId": tenantId
          }
      
       
      }
    ]
  
}})).then(()=>{
  
  setIsQuery(true)
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedRoute({ ...selectedRoute, [field]: event });
  }

  useEffect(
    () => {
      dispatch(pages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages/list`,
        entity: 'pages',
        jsonData: {}
    })).then(()=>{
      dispatch(websites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`,entity:'websites',jsonData:{}}))
    }).then(()=>{
      dispatch(cards.list({url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards/list`,entity: 'cards',jsonData: {   "Filters": [
        {
          "FieldName": "PlatformWebSiteLayoutId",
          "FilterOperatorId": 1,
          "FieldValue": parmas?.id,
          "FieldType": "number"
        }
      ],
      "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc",
}}))
  }).then(()=>{
 
      if (parmas?.id > 0) {
        fetchLayoutById()
        createColumnDefs()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    [pageData]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedRoute(routeQuery?.result?.items)
        setCards(cardList?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const updatedSelectedLayouts = { ...selectedRoute, TenantId: tenantId };
    if (parmas?.id > 0) {
      await dispatch(layouts.resetAction({ actionType: 'update' }))
    await dispatch(layouts.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts`,entity:'layouts',jsonData:{
          
    Records: [
      {
        
        "context": {},
        "message": updatedSelectedLayouts
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(layouts.resetAction({ actionType: 'create' }))
      await dispatch(layouts.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts`,entity:'layouts',jsonData:{
          
      Records: [
        {
        
          "context": {},
          "message": updatedSelectedLayouts
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }
  }

const back=()=>{
  navigate('/web-platform/layouts')
} 


const handleAdd=()=>{
  navigate(`platform-website-layout-card/${0}`)
}
const handleEdit=(data: any)=>{
  navigate(`platform-website-layout-card/${data?.message?.Id}`)
 }
 

 const handleDelete=(data: any)=>{
  dispatch(cards.delete({
    url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards/delete`,
    entity: 'cards',
    jsonData: {
      Records: [
        {
        "context": {},
        "message": {
              Id: data?.message?.Id
          }
        }
      ]
    }
})).then(() => {
  setCards((prevCardDetails: any) => 
    prevCardDetails.filter((item: any) => item.message.Id !== data.message.Id)
  );
  });
}
const additionButtons: any = [
  {
    name: 'Add Cards',
    callback: () => handleAdd(),
  }
];
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <LayoutComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedRoute={selectedRoute}
           pages={formatPageListData(pagesLists?.result?.items)}
           websites={formatWebsiteListData(websitesLists?.result?.items)}
           back={back}
           handleFormSubmit={handleFormSubmit}
           cardDetails={cardDetails}
           columnDefs={columnDefs}
           onEdit={handleEdit}
           additionButtons={additionButtons}
           id={parmas?.id}
           paginationData={cardList?.result?.pagination}
           setPageData={setPageData}
           handleDelete={handleDelete}
          /> 
    } 
          </>
    )
    }
   
    export default Layout;